<gc-text [variant]="'paragraphHeading'">
  {{ paragraphHeadingText }}
</gc-text>

@if (status.length) {
  <div class="status-container">
    <gc-text [variant]="'bodyBold'">{{
      'reportInfo.status' | translate
    }}</gc-text>
    <gc-text>{{ 'reportStatus.' + status | translate }}</gc-text>
  </div>
}
